import { toString } from "cronstrue";
export type CronExpression = string;
export const getCronExpressionDescription = (expression: CronExpression) => {
    return toString(expression);
};
